import { useCurrentWorkspace } from '../store/hooks'

import { BusinessDetails } from '../components/business/BusinessDetails'
import { AccountingYearSettings } from '../components/business/AccountingYearSettings'
import { SceneContainer } from '../components/scene/SceneContainer'
import { VATSettings } from '../components/business/VATSettings'
import { WorkspaceType } from '../lib/db/db.types'

const DetailsScreen = () => {
  const { workspace } = useCurrentWorkspace()

  if (!workspace) {
    return <div>No workspace selected</div>
  }

  if (workspace.spaceType !== WorkspaceType.BUSINESS) {
    return <div>Not a business workspace</div>
  }

  return (
    <SceneContainer>
      <div className="bg-gray-50 p-6 rounded-lg border">
        <BusinessDetails
          name={workspace.business.business.name}
          companyNumber={workspace.business.business.companyNumber}
          companyStatus={workspace.business.business.companyStatus}
          dateOfCreation={workspace.business.business.dateOfCreation}
          address={workspace.business.business.address}
        />

        <AccountingYearSettings
          accountingReferenceDate={workspace.calendarYearEndReferenceDate}
        />

        <VATSettings
          businessId={workspace.id}
          vatSettings={workspace.business.vatSettings}
        />
      </div>
    </SceneContainer>
  )
}

export default DetailsScreen
